import React from 'react'

import { ColumnsType } from 'antd/lib/table'
import moment from 'moment'

import { TaxSavingsType } from 'core/application/expenses/taxSavings/getTaxSavings'

import TaxAdvantage from 'common/components/benefit/Expenses/TaxAdvantageExpense'
import TaxFree from 'common/components/benefit/Expenses/TaxFreeExpense'

import useBreakPoints from 'common/hooks/useBreakPoints'

const onCellStyle = (item, id) => ({
  style: {
    backgroundColor: item.items[id]?.status === 0 ? '#F2F5F7' : '#FFFFFF',
  },
})

const renderStatusAvatar = (
  item: TaxSavingsType,
  onCellItemClick: (item: TaxSavingsType, colKey: number) => void,
  colKey: number,
  isDisabled: boolean,
) => {
  const status = item.items[colKey]?.status

  switch (status) {
    case 2:
      return (
        <div className="flex flex__center t-tax-advantage">
          <TaxAdvantage isAvatarOnly isButtonDisabled={isDisabled} onClick={() => onCellItemClick(item, colKey)} />
        </div>
      )
    case 1:
      return (
        <div className="flex flex__center t-tax-free">
          <TaxFree isAvatarOnly isButtonDisabled={isDisabled} onClick={() => onCellItemClick(item, colKey)} />
        </div>
      )
    default:
      return <div />
  }
}

export const taxSavingsColumns = (
  onCellItemClick: (item: TaxSavingsType, id: number) => void,
  months: string[],
  isDisabled: boolean,
  isMd: boolean,
): ColumnsType<TaxSavingsType> => {
  return months
    ? [
        {
          key: 'name',
          title: 'Name',
          fixed: 'left',
          width: isMd ? 300 : 'auto',
          render: (item) => {
            return (
              <div>
                <div>{item.user?.name}</div>
                {item.relationship ? (
                  <div className="gray-7 mt-8">({item.relationship?.name})</div>
                ) : (
                  <div className="gray-7 mt-8">(You)</div>
                )}
              </div>
            )
          },
        },
        ...months?.map((month, key) => ({
          key: month,
          title: month,
          className: `t-month-${month}`,
          align: 'center' as any,
          onCell: (item) => onCellStyle(item, key),
          render: (item) => renderStatusAvatar(item, onCellItemClick, key, isDisabled),
        })),
      ]
    : []
}

export const taxSavingsTransactionSummaryColumns: ColumnsType<any> = [
  {
    key: 'totalAccrued',
    title: 'Total Accrued',
    className: 't-total-accrued',
    render: (item) => {
      return <div className="color-violet-6">${item.totalAccrued.toFixed(2)}</div>
    },
  },
  {
    key: 'totalRequested',
    title: 'Total Requested',
    className: 't-total-requested',
    render: (item) => {
      return <div>${item.totalRequested.toFixed(2)}</div>
    },
  },
  {
    key: 'totalApproved',
    title: 'Total Approved',
    className: 't-total-approved',
    render: (item) => {
      return <div>${item.totalApproved.toFixed(2)}</div>
    },
  },
  {
    key: 'totalAdvantanged',
    title: 'Total Tax Advantanged',
    className: 't-total-advantage',
    render: (item) => {
      return <div className="color-blue-6">${item.totalTaxAdvantaged.toFixed(2)}</div>
    },
  },
  {
    key: 'totalFree',
    title: 'Total Tax-Free',
    className: 't-total-free',
    render: (item) => {
      return <div className="color-green-6">${item.totalTaxFree.toFixed(2)}</div>
    },
  },
  {
    key: 'remainingExpenses',
    title: 'Remaining Balance',
    className: 't-remaining-expenses',
    render: (item) => {
      return <div>${item.remainingExpenses.toFixed(2)}</div>
    },
  },
]

export const taxSavingsTransactionDetailsColumns: ColumnsType<any> = [
  {
    key: 'transactionDate',
    title: 'Transaction Date',
    className: 't-transaction-date',
    render: (item) => {
      return <div>{moment(item.transactionDate).format('MM/DD')}</div>
    },
  },
  {
    key: 'description',
    title: 'Description',
    className: 't-description',
    render: (item) => {
      return <div>{item.description}</div>
    },
  },
  {
    key: 'amount',
    title: 'Amount',
    className: 't-amount',
    render: (item) => {
      return <div className="color-violet-6">${item.amount.toFixed(2)}</div>
    },
  },
  {
    key: 'unpaidExpenses',
    title: 'Unpaid expenses',
    className: 't-unpaid-expenses',
    render: (item) => {
      return <div>${item.unpaidExpenses.toFixed(2)}</div>
    },
  },
  {
    key: 'balance',
    title: 'Balance',
    className: 't-balance',
    render: (item) => {
      return <div>${item.balance.toFixed(2)}</div>
    },
  },
  {
    key: 'name',
    title: 'Name',
    className: 't-name',
    render: (item) => {
      return <div>{item.name}</div>
    },
  },
]
